export default "__VITE_ASSET__cc9afe58__"